import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { updatedNewTrip } from "../../../../../constant";
import { Dispatch, SetStateAction } from "react";
import { palette, fsPx, sp, fw } from "../../../../../styles/design-tokens";

interface MobileTabsProps {
  value: number;
  handleChange: (event: React.SyntheticEvent, newValue: number) => void;
  setChatInputText: Dispatch<SetStateAction<string>>;
  handleLastTab: () => void;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const MobileTabs = ({ value, handleChange, setChatInputText, handleLastTab }: MobileTabsProps) => {
  return (
    <Tabs
      orientation={"horizontal"}
      value={value}
      onChange={handleChange}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "none",
        "& .MuiTab-root": {
          color: palette["gray-56"],
          fontSize: fsPx(12),
          fontFamily: "var(--brand-font-body)",
          fontWeight: fw(600),
          marginLeft: sp(10),
        },
        "& .Mui-selected": {
          color: "var(--primary-dark-2) !important",
          fontWeight: fw(700),
        },
        "& .MuiTabs-indicator": {
          display: "none",
        },
      }}
    >
      <Tab
        label="HISTORY"
        {...a11yProps(0)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
        onClick={() => {
          setChatInputText("");
        }}
      />
      <Tab
        icon={<img src={updatedNewTrip} alt="" style={{ width: "auto", height: "20px" }} />}
        label="New Trip"
        iconPosition="start"
        {...a11yProps(2)}
        sx={{ alignSelf: "flex-end", mr: 0.5 }}
        onClick={handleLastTab}
      />
    </Tabs>
  );
};
